import type { RequirementClassification } from '../api/requirements';

type Props = {
  readonly classification: RequirementClassification;
};

export function ClassBadge({ classification }: Props) {
  if (classification === 'BUG') {
    return (
      <span className="class-badge class-bug">
        <span className="bar" />
        Bug
      </span>
    );
  }
  if (classification === 'USER_STORY') {
    return (
      <span className="class-badge class-story">
        <span className="bar" />
        User Story
      </span>
    );
  }
  return (
    <span className="class-badge class-unknown">
      <span className="bar" />
      Unklar
    </span>
  );
}
